import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function PurchaseReports(){return <CompanyReportScreen kind="purchases"/>;}
